import React from "react";
import { Button, Form, Modal } from "react-bootstrap";

import { COLOR_WHITE, LINEAR_GRADIENT_BG } from "../../../../const";

export default function EditAttributeModal({
  show,
  onClose,
  attributeName,
  setAttributeName,
  onSave,
  disableClose,
  disableSave,
}) {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 16 }}>ແກ້ໄຂຄຸນລັກສະນະ</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ background: COLOR_WHITE }}>
          <Form.Group>
            <Form.Label>ຊື່ຄຸນລັກສະນະ</Form.Label>
            <Form.Control
              value={attributeName}
              onChange={(e) => setAttributeName(e.target.value)}
              placeholder="Size, Color"
            />
          </Form.Group>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onClose} disabled={disableClose}>
          ຍົກເລີກ
        </Button>
        <Button
          style={{ background: LINEAR_GRADIENT_BG, border: "none" }}
          onClick={onSave}
          disabled={disableSave}
        >
          ບັນທຶກ
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
